import { memo, useMemo } from 'react';
import { HashRouter, MemoryRouter, Navigate, Route, Routes } from 'react-router';

import Main from './components/Main';
import { useMatchesCalendarMenu } from './hooks/menu';
import { MatchesCalendarFeedProvider, MatchesCalendarOptionsProvider } from './store';
import type { MatchesCalendarOptions } from './store/types';
import { MatchesCalendarData } from './store/types';

const Calendar = ({ options }: { options: MatchesCalendarOptions }) => {
  const selectedTeamId = +options.selectedTeamId > 0 ? options.selectedTeamId : null;

  const Router = options.disableRouting ? MemoryRouter : HashRouter;
  const mode = useMatchesCalendarMenu(options);

  const activeData = useMemo(
    () => ({
      [MatchesCalendarData.MATCHES]: true,
      [MatchesCalendarData.FRIENDLIES]: options.includeFriendlies,
      [MatchesCalendarData.DRAWS]: true,
    }),
    [options.includeFriendlies],
  );

  const state = useMemo(
    () => ({ mode, filters: { teamId: selectedTeamId }, activeData }),
    [mode, selectedTeamId, activeData],
  );

  return (
    <MatchesCalendarOptionsProvider options={options}>
      <MatchesCalendarFeedProvider key={mode} state={state}>
        <Router>
          <Routes>
            <Route index element={<Main />} />
            {!options.showAllMatches && <Route path=':type/:tabId' element={<Main />} />}
            <Route path='*' element={<Navigate to='/' />} />
          </Routes>
        </Router>
      </MatchesCalendarFeedProvider>
    </MatchesCalendarOptionsProvider>
  );
};

export default memo(Calendar);
